import { NAME } from "./constants";
import { getCustomReducer, getCustomSaga } from "./redux";
import { CustomizationModule } from "./types";

export { ReduxModuleName, ReduxRegistrator } from "./ReduxRegistrator";
export { ICustomizationState } from "./types";
export { createGetInjectedComponent, createGetInjectedComponentOnRender, createRegisterReplaceableComponents, getCustomStateSubtree } from "./utils";

export const customizationModule: CustomizationModule = {
    getSaga: getCustomSaga,
    getReducer: getCustomReducer,
    NAME,
};
